import {
  Measure,
  Validation,
  mustBeLessOrEqual,
  NullableMeasure,
  InputFieldType,
  convertMeasure,
  isMeasureWithValue,
} from '@e2m-customer-portal/shared';
import { ForecastPageLimitsResponse } from '../../generated/graphql';
import { useTranslation } from 'react-i18next';

export function useBandRules(
  product: InputFieldType,
  limits: ForecastPageLimitsResponse,
): Validation<NullableMeasure>[] | undefined {
  const [t] = useTranslation('validation');
  const rules: Validation<NullableMeasure>[] = [];
  // Validations  MFRR_POS_01, AFRR_POS_01
  if (product === InputFieldType.AFRR_POSITIVE || product === InputFieldType.MFRR_POSITIVE) {
    const value = limits.fields.find((field) => field.type === product)?.positiveBand;
    if (value) {
      const msg = t('PRODUCT_FLEXIBILITY_GREATER_THAN_MAXIMUM_FLEX_BAND', {
        value: convertMeasure(value, 'kW').value,
      });
      rules.push(mustBeLessOrEqual(value as Measure, msg));
      return rules;
    }
  }
  // Validations FCR_BAND_02
  if (product === InputFieldType.FCR) {
    const value = limits.fields.find((field) => field.type === product)?.positiveBand;
    if (value) {
      const msg = t('PRODUCT_FLEXIBILITY_GREATER_THAN_MAXIMUM_FLEX_BAND', {
        value: convertMeasure(value, 'kW').value,
      });
      rules.push(mustBeLessOrEqual(value as Measure, msg));
      return rules;
    }
  }
  // Validations MFRR_NEG_01, AFRR_NEG_01
  if (product === InputFieldType.AFRR_NEGATIVE || product === InputFieldType.MFRR_NEGATIVE) {
    const value = limits.fields.find((field) => field.type === product)?.negativeBand;
    if (value) {
      const msg = t('PRODUCT_FLEXIBILITY_GREATER_THAN_MAXIMUM_FLEX_BAND', {
        value: convertMeasure(value, 'kW').value,
      });
      rules.push(mustBeLessOrEqual(value as Measure, msg));
      return rules;
    }
  } else {
    // Validations FCR_BAND_02, MFRR_POS_02, MFRR_NEG_02, AFRR_POS_02, AFRR_NEG_02
    if (limits.installedPower && isMeasureWithValue(limits.installedPower)) {
      const msg = t('COMMON_GREATER_THAN_INSTALLED_POWER', {
        value: convertMeasure(limits.installedPower, 'kW').value,
      });
      rules.push(mustBeLessOrEqual(limits.installedPower, msg));
    }
    return rules;
  }
  return rules;
}
